import React from 'react';
import classnames from 'classnames';
import { BodyText } from '../../BodyText';
import { Button } from '../../Button';
import { Stack } from '../../Stack';
import { Icon } from '../../Icon';
import { FocusActionType, FocusContext } from '../utils';
import { keys } from '../../../utilities/keyCodes';
export const SelectDrillInHeader = ({ className, onBack, title, closeSelectHandler, preventFocus, }) => {
    const SelectDrillInHeaderClassNames = classnames(className, 'SelectDrillIn__header');
    const focusContext = React.useContext(FocusContext);
    const { focusDispatch } = focusContext;
    const backButtonRef = React.useRef(null);
    React.useEffect(() => {
        var _a;
        if (!preventFocus)
            (_a = backButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [backButtonRef, preventFocus]);
    const handleKeyDown = (e) => {
        if (e.key === keys.enter || e.key === keys.esc) {
            onBack(e);
            focusDispatch({
                type: FocusActionType.SetFocus,
                payload: { filterFocus: true },
            });
            return;
        }
        if (e.key === keys.tab && e.shiftKey) {
            onBack(e);
            closeSelectHandler();
        }
    };
    return (React.createElement(Stack, { className: SelectDrillInHeaderClassNames, alignItems: "center" },
        React.createElement("span", { className: "Select__focus", tabIndex: 0, ref: backButtonRef, onKeyDown: handleKeyDown },
            React.createElement(Icon, { className: "BackLink__back-icon cursor-pointer SelectDrillIn__back", name: "chevron_left", onClick: onBack, size: "20px" })),
        title && (React.createElement(BodyText, { className: "SelectDrillIn__title ff-display lh-1 ta-center flex-grow-1", bold: true, size: "small" }, title))));
};
export const SelectDrillInFooter = ({ footerActionName, footerOnActionClick, closeSelectHandler, onBack, }) => {
    const SelectDrillInFooterClassNames = classnames('AnvilDropdown__footer w-100');
    const hasAction = !!(footerActionName && footerOnActionClick);
    const handleKeyDown = (e) => {
        if (e.key === keys.enter) {
            footerOnActionClick(e);
            return;
        }
        if (e.key === keys.tab && !e.shiftKey) {
            onBack(e);
            closeSelectHandler();
        }
    };
    if (!hasAction) {
        return null;
    }
    return (React.createElement(Stack, { alignItems: "center", justifyContent: "flex-end", className: SelectDrillInFooterClassNames },
        React.createElement(Button, { primary: true, xsmall: true, onClick: footerOnActionClick, className: "Select__focus", tabIndex: 0, onKeyDown: handleKeyDown }, footerActionName)));
};
export const SelectDrillInContent = ({ className, content, }) => {
    return React.createElement("div", { className: className }, content);
};
//# sourceMappingURL=DrillIn.js.map